export default "__VITE_ASSET__DpQ_oET5__"